(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["minimal-sticky-atc"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('pet-sticky-atc')) {
    customElements.define('pet-sticky-atc', class extends HTMLElement {
      connectedCallback() {
        this.querySelector('button')?.addEventListener('click', () => {
          const section = document.querySelector(`#MainProduct-${this.dataset.sectionId}`);
          const submit = section?.querySelector('.product-form__submit');
          submit?.click();
        });
      }
    });
  }
  } catch(e) { console.error(e); }
})();

})();
